import React from "react";
import { Building2, Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmptyState({ onSync, syncBusy }) {
  return (
    <div className="text-center py-12 px-4">
      <Building2 className="h-12 w-12 text-slate-300 mx-auto mb-3" />
      <h2 className="text-lg font-semibold text-slate-900">No brokerages yet</h2>
      <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">
        Sync addresses to derive brokerage offices from your realtor list using Google
        Places.
      </p>
      {onSync ? (
        <Button
          onClick={onSync}
          disabled={syncBusy}
          className="mt-4 text-white min-h-[44px]"
          style={{ background: "hsl(var(--brand))" }}
          data-testid="brokerages-empty-sync-button"
        >
          {syncBusy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Sparkles className="h-4 w-4 mr-2" />}
          {syncBusy ? "Syncing…" : "Sync addresses from realtors"}
        </Button>
      ) : null}
    </div>
  );
}
